import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function StaffCreatedModal({
  isOpen,
  createdStaff,
  onClose,
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCopied(false);
    }
  }, [isOpen]);

  if (!isOpen || !createdStaff) return null;

  const credentialsText = `Staff Login Details
Name: ${createdStaff.first_name} ${createdStaff.last_name}
Staff ID: ${createdStaff.staff_id}
PIN: ${createdStaff.pin}`;

  const handleCopyCredentials = async () => {
    try {
      await navigator.clipboard.writeText(credentialsText);
      setCopied(true);
    } catch (error) {
      console.error("Failed to copy credentials:", error);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/50 p-4">
      <div className="flex max-h-[95vh] w-full max-w-lg flex-col rounded-3xl bg-white shadow-2xl">
        <div className="flex shrink-0 items-start justify-between border-b border-slate-200 px-6 py-5">
          <div>
            <h2 className="text-xl font-semibold text-slate-900">
              Staff Created Successfully
            </h2>
            <p className="mt-1 text-sm text-slate-500">
              Share these login details with the staff member.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 text-2xl leading-none text-slate-500 hover:bg-slate-100"
          >
            ✕
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            <div className="rounded-2xl bg-slate-50 p-4">
              <p className="text-sm text-slate-500">Name</p>
              <p className="mt-1 text-base font-semibold text-slate-900">
                {createdStaff.first_name} {createdStaff.last_name}
              </p>
            </div>

            <div className="rounded-2xl bg-slate-50 p-4">
              <p className="text-sm text-slate-500">Staff ID</p>
              <p className="mt-1 text-lg font-bold text-slate-900">
                {createdStaff.staff_id}
              </p>
            </div>

            <div className="rounded-2xl bg-slate-50 p-4">
              <p className="text-sm text-slate-500">PIN</p>
              <p className="mt-1 text-lg font-bold text-slate-900">
                {createdStaff.pin}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-slate-200 px-6 py-5 shrink-0 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={handleCopyCredentials}
            className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            {copied ? "Copied!" : "Copy Credentials"}
          </button>

          <button
            type="button"
            onClick={onClose}
            className="rounded-xl bg-slate-900 px-5 py-3 text-sm font-medium text-white hover:bg-slate-800"
          >
            Done
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}